import PuzzleData from '../PuzzleData';

// Complete puzzle builder
export default function buildPuzzle(progress) {
  const docFrag = document.createDocumentFragment();
  const cubeTemplate = document.getElementById('HeroCubeTemplate').content;

  progress.forEach((cube) => {
    docFrag.appendChild(buildCube(cube, cubeTemplate));
  });

  return docFrag;
}

// Individual cube
function buildCube(cube, template) {
  const cubeNode = template.cloneNode(true);

  for (const face in cube) {
    if (Object.prototype.hasOwnProperty.call(cube, face)) {
      modifyFace(face, cube[face], cubeNode);
    }
  }

  return cubeNode;
}

// Each cube face
function modifyFace(direction, face, cubeNode) {
  const id = Object.keys(face)[0];
  const faceData = PuzzleData.Faces[direction][id];
  const faceWrapper = cubeNode.querySelector(`[data-face="${direction}"]`);
  const faceNode = faceWrapper.querySelector('.Face');

  faceWrapper.id = id;
  faceWrapper.classList.add('draggable-source');

  if (faceData.track === 0) {
    faceNode.classList.add('Face--isBlank');
  }

  if (faceData.piece) {
    faceNode.appendChild(buildPiece(faceData.piece, faceData.angle));
  }
}

// Single puzzle piece
function buildPiece(piece, angle) {
  const pieceNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const symbolNode = document.createElementNS('http://www.w3.org/2000/svg', 'use');

  const classes = ['Svg'];
  classes.push(angle ? `Svg--rotate${angle}` : null);

  pieceNode.setAttribute('viewBox', '0 0 80 80');
  pieceNode.setAttribute('class', classes.join(' '));
  symbolNode.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `#SVGPiece${piece}`);

  pieceNode.appendChild(symbolNode);

  return pieceNode;
}
